import { getEnv } from 'helpers/common'
import { formatMobilePhone } from 'helpers/formatPhone'

export const SUPPORT_TEL = '88002504099'
export const SUPPORT_TEL_FORMATTED = formatMobilePhone(SUPPORT_TEL, {
  mask: '# 000 000 00-00',
  definitions: { '#': /[7-8]/ }
})

export const LANDING_ROOT_LINK = `${getEnv('VITE_REACT_APP_LANDING_URL')}`
